import * as n from "react";
import { T as o } from "./identifier-Cgsu5TYh.mjs";
function r(e) {
  return Object.keys(e).length === 0;
}
function s(e = null) {
  const t = n.useContext(o);
  return !t || r(t) ? e : t;
}
export {
  s as u
};
